// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"U3-z","dimensionLabel":"V3-z","styleChooserControlWrapper":"W3-z","styleChooserControl":"X3-z","disabled":"Y3-z","giftCard":"Z3-z","styleChooserText":"_3-z"};